import { useLocation } from "react-router-dom";

/** Every Ready to build list starts closed (Noaa, 18 Oct 2026), except where a link landed
 * on it, so following one to a specialist's checklist still shows it. */
export const useReadyToBuildOpen = (): boolean =>
  useLocation().hash === "#ready-to-build";
